import Calculator from './Calculator.svelte';

const calcs = [];
const targets = document.querySelectorAll('.niddk-diabetes-risk-mgmt-calc');

for (const target of targets) {
	const calc = new Calculator({
		target
	});
	calcs.push(calc);
}

export default calcs;
